import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  max-height: ', ';\n  overflow: ', ';\n  background-color: ', ';\n'], ['\n  max-height: ', ';\n  overflow: ', ';\n  background-color: ', ';\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  align-items: center;\n  background-color: ', ';\n  color: ', ';\n  display: flex;\n  fill: ', ';\n  font-weight: 500;\n  justify-content: center;\n  padding: ', 'px;\n  text-align: center;\n  ', '\n\n  margin: auto;\n  ', ' transition: color ', ';\n\n  a,\n  a:visited,\n  a:hover,\n  a:active,\n  a:focus {\n    color: ', ';\n    text-decoration: underline;\n  }\n'], ['\n  align-items: center;\n  background-color: ', ';\n  color: ', ';\n  display: flex;\n  fill: ', ';\n  font-weight: 500;\n  justify-content: center;\n  padding: ', 'px;\n  text-align: center;\n  ', '\n\n  margin: auto;\n  ', ' transition: color ', ';\n\n  a,\n  a:visited,\n  a:hover,\n  a:active,\n  a:focus {\n    color: ', ';\n    text-decoration: underline;\n  }\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  flex: 0 0 auto;\n'], ['\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  flex: 0 0 auto;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n        text-overflow: ellipsis;\n        white-space: nowrap;\n      '], ['\n        text-overflow: ellipsis;\n        white-space: nowrap;\n      ']),
    _templateObject5 = _taggedTemplateLiteral(['\n  max-height: ', 'px;\n  overflow: hidden;\n  transition: max-height ', ';\n'], ['\n  max-height: ', 'px;\n  overflow: hidden;\n  transition: max-height ', ';\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  flex: 0 1 auto;\n  padding-left: ', 'px;\n  ', ';\n  overflow: hidden;\n'], ['\n  flex: 0 1 auto;\n  padding-left: ', 'px;\n  ', ';\n  overflow: hidden;\n']);

import styled, { css } from 'styled-components';
import { colors, gridSize, math, themed } from '@atlaskit/theme';

var TRANSITION_DURATION = '0.25s ease-in-out';

// Container
export var getMaxHeight = function getMaxHeight(_ref) {
  var appearance = _ref.appearance;
  return appearance === 'announcement' ? '88px' : '52px';
};

export var backgroundColor = themed('appearance', {
  error: { light: colors.R400, dark: colors.R300 },
  warning: { light: colors.Y300, dark: colors.Y300 },
  announcement: { light: colors.N500, dark: colors.N500 }
});

export var Container = styled.div(_templateObject, getMaxHeight, function (_ref2) {
  var appearance = _ref2.appearance;
  return appearance === 'announcement' ? 'scroll' : 'visible';
}, backgroundColor);

export var testErrorBackgroundColor = colors.R400;
export var testErrorTextColor = colors.N0;

export var textColor = themed('appearance', {
  error: { light: colors.N0, dark: colors.DN40 },
  warning: { light: colors.N700, dark: colors.DN40 },
  announcement: { light: colors.N0, dark: colors.N0 }
});
export var Content = styled.div(_templateObject2, backgroundColor, textColor, backgroundColor, math.multiply(gridSize, 2), '' /* transition: color ${TRANSITION_DURATION}; */, function (_ref3) {
  var appearance = _ref3.appearance;
  return appearance === 'announcement' ? 'max-width: 876px;' : '';
}, TRANSITION_DURATION, textColor);

export var Icon = styled.span(_templateObject3);

var textOverflow = function textOverflow(_ref4) {
  var appearance = _ref4.appearance;
  return appearance === 'announcement' ? '' : css(_templateObject4);
};

export var Visibility = styled.div(_templateObject5, function (_ref5) {
  var bannerHeight = _ref5.bannerHeight,
      isOpen = _ref5.isOpen;
  return isOpen ? bannerHeight : 0;
}, TRANSITION_DURATION);

export var Text = styled.span(_templateObject6, math.divide(gridSize, 2), textOverflow);